<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <div class="project-page-content">

        <div style="margin-top: 42px; margin-bottom: 48px;padding-right: 24px;" *ngIf="adminOrgs.length > 0">

          <!-- system admins and org admins may create projects in their administered orgs -->

          <p-inputgroup>

            <p-dropdown
              id="orglistpickerlight"
              class="light"
              [disabled]="adminOrgs.length == 0"
              [options]="adminOrgs"
              autoDisplayFirst="true"
              optionLabel="name"
              optionValue="id"
              [(ngModel)]="selectedOrg"
              scrollHeight="200"
              (onChange)="orgChange($event)"
            >
            </p-dropdown>

            <input (keyup)="checkKey()" id="createprojectkeylight" type="text" pInputText placeholder="Key">
            <input (keyup)="checkKey($event)" id="createprojectlight" type="text" pInputText placeholder="New Project">

            <div *ngIf="prjInputValid; then checkButton else cancelButton"></div>
            <ng-template #checkButton>
              <button (click)="createProject()" type="button" pButton pRipple icon="pi pi-check" [class.p-button-danger]="!prjInputValid" [class.p-button-success]="prjInputValid"></button>
            </ng-template>

            <ng-template #cancelButton>
              <button (click)="createProject()" type="button" pButton pRipple icon="pi pi-times" [class.p-button-danger]="!prjInputValid" [class.p-button-success]="prjInputValid"></button>
            </ng-template>

          </p-inputgroup>

          <div>
            <p class="prjcreateerror"></p>
          </div>

        </div>

        <div *ngIf="(projects.length == 0) && (adminProjects.length == 0); else elseBlock">

          <!-- they aren't in any projects yet. -->

          <p><i>Not yet a member of any project.</i></p>

        </div>

        <ng-template #elseBlock>

          <!-- member of at least one project -->

          <div *ngIf="adminProjects.length">

            <h6>Administrator Of</h6>

            <project-list-component
              [editable]="true"
              [projects]="adminProjects"
              (projectDeleted)="projectDeleted($event)"
            >

            </project-list-component>

          </div>

          <div *ngIf="projects.length">

            <br/><br/>

            <h6>Member Of</h6>

            <project-list-component [projects]="projects"></project-list-component>

          </div>

        </ng-template>

        <div style="margin-top: 24px; width: 650px;">

          <p-accordion class="light">

            <p-accordionTab header="Help">

              <p>Each project has access to some number of sub-divisions of the rail network. In
                turn you have access to any panoramas that are within the scope, of any project
                you are a member of.  If you can not see any panoramas, join a project!  Normally
                you will be added to a project by your organizational administrator when your
                account is approved.</p>

              <p>If you require access to additional projects or you were not added to a project,
                please contact your manager for further assistance.</p>

              <p>To create a new Project use the Create input below.
                Note that projects require a unique key and a name.  The unique key can start with A-Z,
                and the rest of the key can be _, A-Z, or 0-9.  All projects must also belong to an
                organization.
              </p>

            </p-accordionTab>

          </p-accordion>

        </div>

      </div>

    </div>
    <div id="pano-footer" class="pano-footer"></div>
  </div>
</div>
